import { combineReducers } from 'redux';
import { routerReducer } from 'connected-react-router';
import { heartbeat, historyBlocking, user, userIsLoading } from './reducers-app';
import { reducer as formReducer } from 'redux-form'

import { columns, rules, ruleSubmitting, ruleDeleting, errorOnRuleCreation,validateWorkTags, errorOnScan } from './reducers-rules';
import { filteredColumns } from './reducers-filter-columns';
import { rowFilters } from './reducers-datagrid';
import { statsColumns, stats, statsLoading } from './reducers-stats';


export default combineReducers({
    form: formReducer,
    routing: routerReducer,
    columns,
    rowFilters,
    filteredColumns,
    rules,
    ruleSubmitting,
    errorOnRuleCreation,
    ruleDeleting,
    heartbeat,
    historyBlocking,
    user,
    userIsLoading,
    statsLoading,
    statsColumns,
    stats,
    validateWorkTags,
    errorOnScan
})


// WEBPACK FOOTER //
// ./src/reducers/reducers-index.js